import React from "react";
import Chart from "react-apexcharts";

const AreaChart = ({chartData}) => {
  return <Chart options={chartData} series={chartData.series} width="100%" height="500px" className="areaChart" />;
};

export default AreaChart;
